import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ActionsState, OutcomeAssessmentState } from './actions.types';

export const selectActionsState = createFeatureSelector<ActionsState>('actions');

export const selectActionsList = createSelector(selectActionsState, (state) => state.actionsList);
export const selectActionsLoading = createSelector(selectActionsState, (state) => state.actionsLoading);
export const selectOutcomeAssessmentsState = createSelector(selectActionsState, (state) => state.outcomeAssessmentsMap);
export const selectOutcomeAssessmentsForAction = (props: { actionId: string }) =>
  createSelector(
    selectOutcomeAssessmentsState,
    (outcomeAssessments: { [actionId: string]: OutcomeAssessmentState[] }) =>
      outcomeAssessments[props.actionId] ?? undefined
  );
